const CarBrand = () =>
  import(
    /* webpackChunkName: "base-info-car-brand" */ '@/pages/base-info/car/brand/index.vue'
  )
const CreateCarBrand = () =>
  import(
    /* webpackChunkName: "base-info-car-brand" */ '@/pages/base-info/car/brand/create.vue'
  )
const EditCarBrand = () =>
  import(
    /* webpackChunkName: "base-info-car-brand" */ '@/pages/base-info/car/brand/edit.vue'
  )

export default {
  path: 'brand',
  meta: {
    label: 'carBrand',
    auth: 'brand'
  },
  component: {
    name: 'Brand',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCarBrand',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: CarBrand
    },
    {
      name: 'BaseInfoCreateCarBrand',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCarBrand
    },
    {
      name: 'BaseInfoEditCarBrand',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCarBrand,
      props: true
    }
  ]
}
